<template>
<!-- 应急处置列表 -->
  <div class="main">
    <div class="box">
      <div class="header">
        安全管理>应急处理  
      </div>
      <div class="table">
        <div class="table-top">
          <div class="grid-search">
              <!-- <el-date-picker
                  v-model="search.date"
                  align="right"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  style="margin-right:1vw;"
                  @change="doFilter"
              ></el-date-picker> -->
              <!-- <el-input v-model="search.type" style="width:200px" placeholder="请输入类型名称" clearable @change="doFilter">
                <el-button slot="append" icon="el-icon-search" @click="a"></el-button>
              </el-input> -->
              <el-select @change="a" clearable v-model="search.type" placeholder="请选择类型">
                <el-option
                  label="环境"
                  value="1">
                </el-option>
                <el-option
                  label="事故"
                  value="2">
                </el-option>
              </el-select>
            </div>
            <button class="addwuzi" @click="addLog">添加</button>
        </div>
        <div class="title">
          <div class="item">序号</div>
          <div class="item">类型</div>
          <div class="item">使用物资</div>
          <div class="item">应用内容</div>
          <div class="item">时间</div>
        </div>
        <div class="scroll">
          <div class="content-i" v-for="(item,index) in listData" :key="index">
          <div class="text">{{((currentPage - 1) * pageSize)+(index+1)}}</div>
          <div class="text">{{getTypeName(item.type)}}</div>
          <div class="text wuzi">
            <div v-for="(text,num) in item.proEmergencyProcessingDetails" :key="num" style="margin:5px 0;">
              <span>物资：{{text.suppliesName}}</span>
              <span>数量：{{text.count}}</span>
            </div>
            
          </div>
          <div class="text">{{item.content}}</div>
          <div class="text">{{item.createDate}}</div>
        </div>
        </div>
        <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import myHttp from '../../../untils/port';
import util from '../../../untils/util';
export default {
  data(){
    return{
      search:{
        date:'',
        type:'',
        createBy:'',
        useType:''
      },
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      listData:[//数据列表
        // {id:'1',type:'1',typeName:'环境',contain:'大雨来袭，使用应急雨衣。',mate:[{id:"1",name:'雨衣',num:'5'}],createTime:'2021-07-08'}
      ],
      dataText:'数据加载中...',//提示
      // portList:[],//
      // userTypeList:[],//平台端
      typeList:[],
    }
  },
  mounted(){
    this.getType()
    // this.getUserType()
    this.getData()
  },
  methods:{
    addLog(){
      this.$router.push({path:'/emerHardAdd/0'})
    },
    //获取平台端
    // getUserType(){
    //   var that = this
    //   myHttp.getDictByType({
    //       type:'user_type'
    //   }).then(function(resp){
    //       if(resp.data.code=='200'){
    //           var list = resp.data.data.dictList||[]
    //           that.userTypeList = list
    //       }else{
    //           that.$message.error(resp.data.msg)
    //       }
          
    //   })
    // },
    //获取更新端
    getType(){
      var that = this
      myHttp.getDictByType({
          type:'handler_type'
      }).then(function(resp){
          if(resp.data.code=='200'){
              var list = resp.data.data.dictList||[]
              that.typeList = list
          }else{
              that.$message.error(resp.data.msg)
          }
          
      })
    },
    getTypeName(id){
      var result = ''
      for(var i=0;i<this.typeList.length;i++){
        if(id == this.typeList[i].value){
          result = this.typeList[i].label
        }
      }
      return result
    },
    // 搜索数据
    doFilter() {
      this.currentPage = 1
      this.getData();
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentChangePage()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.currentChangePage();
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData();
    },
    a(){
      
      this.getData();
    },
    //获取数据
    getData(){
      var that = this
    //   this.dataText = '暂无数据'
      this.search.pageNum = this.currentPage
      this.search.pageSize = this.pageSize
      myHttp.selectProEmergencyProcessingPage(this.search).then(function(resp){
          if(resp.data.code=='200'){
              var list = resp.data.data.pageInfo.list||[]
              that.listData = list
              that.totalItems = resp.data.data.pageInfo.total||0
              if(list.length==0){
                  that.dataText = '暂无数据'
              }
          }else{
              that.dataText = '暂无数据'
          }
      })
    },

    //修改
    handleEdit(index,row){
        this.$router.push({path:'/emerHardAdd/'+row.id})
    },

    //进入添加页面
    addLog(){
      this.$router.push({path:'/emerHardAdd/0'})
    },

    //删除
    handleDelete(index,row){
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.deleteSysSystemUpdateLog({
            id: row.id
        }).then(function(resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
        })
      }).catch(() => {
        
      })
    },
  }
}
</script>

<style scoped>
  .log-box{
    width: 100%;
    height: 100%;
    position: relative;
  }
  .box-head{
    width: 100%;
    height: 7vh;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    padding: 0 1vw;
    background: #fff;
    border-bottom: 2px solid #409EFF;
    justify-content: space-between;
  }
  .box-main{
    width: 100%;
    height: calc( 100% - 12vh );
    position: relative;
    background: #fff;
  }
</style>

<style>
  .main{
  flex: 1;
  background-color: #f6f5f8;
  padding-left:8px ;
  padding-right:24px ;
}
.table{
  height: 83vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0vw 0vw 0.6vw 0vw 
		rgba(105, 159, 204, 0.5);
}
.table::-webkit-scrollbar{
  width: 0;
  height: 0;
}
.scroll{
  height: 66vh;
  overflow: scroll;
}
.scroll::-webkit-scrollbar{
  width: 0;
  height: 0;
}
.table-top{
  min-height: 6vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 9px 0 9px;
}
.addwuzi{
  background-color: #0b62f0;
  color: #fff;
  width: 120px;
  height: 4vh;
  font-family: PingFang-SC-Medium;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #ffffff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.title{
  height: 6vh;
  min-height: 6vh;
  background-color: #dfe1e3;
  display: flex;
  font-family: PingFang-SC-Bold;
	font-size: 22px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
}
.item, .text{
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-i{
  min-height: 6vh;
  display: flex;
  background-color: #fff;
  border-bottom: 1px solid #e7e7e7;
  font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #666666;
}
.content-i:hover{
  background-color: #e1edf8;
}
.btn{
  display: flex;
  justify-content: center;
  font-family: PingFang-SC-Medium;
	font-size: 20px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0vh;
	color: #2e5be9;
}
.btn>.btn-l{
  margin-right: 5px;
}
.btn>.btn-r{
  margin-left: 5px;
}
.header{
  display: flex;
  min-height: 6vh;
  line-height: 6vh;
  font-family: PingFang-SC-Regular;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #000000;
}
.el-pagination{
  background-color: #dfe1e3;
}
.wuzi{
  display: flex;
  flex-direction: column;
}
</style>